import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Developer Options',
  attributeName: 'developerOptions',
  fields: [
    {
      attributeName: 'logManagerConfig',
      label: 'Log Manager Config',
      helpText: 'The number of columns the main panel must present.',
      default: ["release"],
      type: FormInputTypes.SELECT,
      options: [
        { name: "release", value: "release" },
        { name: "debug", value: "debug" },
      ],
    },
  ],
};
